/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import ProfileImage from '../assets/image/me.png';

const Home: React.FC = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="head--middle fade-transition">
        <div>
          {!imageLoaded && (
            <div className="text-center my-5" role="status" aria-live="polite">
              <span className="loader" />
                <p>Loading image ...</p>
            </div>
          )}
          <img 
            className={`${imageLoaded ? 'd-block' : 'd-none'}`}
            src={ProfileImage} 
            alt="Profile image"
            loading="lazy"
            onLoad={() => setImageLoaded(true)}
            />
        </div>
        <div className="text-content">
            <div className="title mb-1">
                <h1 className="primary-color bold text-shadow">Welcome</h1>
            </div>
            <div className="info my-5">
              <p>
                    I'm <span className="bold"> Bello Ibrahim</span>,
                    a seasoned IT professional with a degree in Computer Science. I have successfully collaborated with various organizations to drive digital transformation and IT automation, optimizing end-to-end business operations. My expertise lies in leveraging technology to solve complex challenges and deliver tangible results.
              </p><br />

              <p>
                  As technology continues to evolve, I am committed to staying ahead of the curve. I actively pursue learning opportunities on top-tier platforms to expand my skill set and explore emerging technologies such as C, Python, MySQL, PHP, JavaScript, and more.
              </p> <br />

            <p>
                  I strongly believe in the power of collaboration and teamwork. Whether you're interested in discussing software development, Tech support, sharing insights, or exploring potential partnerships, I am open to connecting. Let's inspire and learn from each other to create innovative solutions and drive progress.
              </p> <br />

              <p>
                  Thank you for visiting my profile. Whether you are a fellow industry professional, a hiring manager, or simply someone passionate about technology, I welcome the opportunity to connect and engage in meaningful conversations. Together, let's shape the future with cutting-edge technology.
              </p>
              <br />              
                
                <p>
                  With 💖,
                </p>
                <p className="mb-3">
                  Bello Ibrahim.
                </p>
            </div>
        </div>
      </div>
  );
};

export default Home;
